<template>
  <v-col
    :cols="options.grid"
    :offset="options.grid_offset"
    :class="options.margin_top ? `mt-0` : ''"
  >
    <InputText
      v-model.trim="value"
      :readOnly="readOnly"
      :disabled="loading"
      v-if="field.field_type === 'input_text'"
      :field="field"
      :dependencyFieldId="dependencyFieldId"
      :dependencyAnswer="dependencyAnswer"
      @change="debouncedupdateAnswer"
    />
    <InputTextArea
      v-model="value"
      :readOnly="readOnly"
      :disabled="loading"
      v-else-if="field.field_type === 'input_text_area'"
      :field="field"
      @change="debouncedupdateAnswer"
    />
    <InputTime
      v-model.trim="value"
      :readOnly="readOnly"
      :disabled="loading"
      v-else-if="field.field_type === 'input_time'"
      :field="field"
      @change="debouncedupdateAnswer"
    />
    <InputFile
      v-else-if="field.field_type === 'input_file'"
      v-model.trim="value"
      :readOnly="readOnly"
      :field="field"
      :answer="answer"
      @change="debouncedupdateAnswer"
    />
    <span v-else-if="field.field_type === 'hidden'"></span>
    <div
      class="image_parent fill-height "
      v-else-if="field.field_type === 'show_image'"
    >
      <v-img :src="image" class="image" contain position="center" />
    </div>
  </v-col>
</template>

<script>
import InputText from "@/components/dynamic_form/fields/input_text.vue";
import InputTextArea from "@/components/dynamic_form/fields/input_text_area.vue";
import InputTime from "@/components/dynamic_form/fields/input_time.vue";
import InputFile from "@/components/dynamic_form/fields/input_file.vue";

import defaultImage from "@/assets/mini-logo.svg";
import rosaVentos from "@/assets/rosa_ventos.png";

export default {
  name: "DynamicFormField",
  props: {
    field: Object,
    readOnly: Boolean,
    answerGroup: Object,
    createAnswerGroup: Function,
    saveAnswer: Function,
  },
  components: {
    InputText,
    InputTextArea,
    InputTime,
    InputFile,
  },
  data() {
    return {
      loading: false,
      value: "",
    };
  },
  created: function() {
    this.debouncedupdateAnswer = this.lodash.debounce(this.updateAnswer, 500);
  },
  mounted() {
    this.value = this.answerValue;

    if (!this.value) {
      if (this.options?.default_value) {
        this.value = this.options.default_value;
      }
    }
  },
  watch: {
    answerValue() {
      this.value = this.answerValue;
    },
  },
  computed: {
    options() {
      if (this.field) {
        return this.field.options;
      }

      return {};
    },
    answer() {
      if (this.answerGroup) {
        let answers = this.answerGroup.answers;
        return this.lodash.find(
          answers,
          (answer) => answer.dynamic_form_field_id === this.field.id
        );
      }

      return null;
    },
    answerValue() {
      if (this.answer) {
        return this.answer.value;
      }

      return "";
    },
    image() {
      if (this.options.image_name === "rosa_ventos") {
        return rosaVentos;
      }

      return defaultImage;
    },
    dependencyFieldId() {
      if (this.field?.dependent_of?.id) {
        return this.field.dependent_of.id;
      }

      return null;
    },
    dependencyAnswer() {
      if (this.dependencyFieldId) {
        if (this.answerGroup) {
          let answers = this.answerGroup.answers;
          return this.lodash.find(
            answers,
            (answer) => answer.field.id === this.dependencyFieldId
          );
        }
      }

      return null;
    },
  },
  methods: {
    updateAnswer() {
      if (this.readOnly) return;

      this.loading = true;
      this.saveAnswer({
        fieldId: this.field.id,
        value: this.value,
      }).then(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.image_parent {
  position: relative;

  .image {
    height: 100px;
    top: -30px;
    position: absolute;
  }
}
</style>
